import { Link } from "react-router-dom";

/**
 * Preis-Tabellenkarte im ZWILLINGSWERK-Look (Zebra-Zeilen, Netto/Brutto).
 * rows: [{ name, unit, netto, brutto, highlight? }]
 */
export default function PriceTable({ title, subtitle, badge, rows, footnote, testid }) {
  return (
    <div
      className="bg-white rounded-xl border border-[#D7E5D9] shadow-sm overflow-hidden flex flex-col justify-between"
      data-testid={testid}
    >
      <div>
        <div className="bg-[#122B18] text-white p-5 flex items-center justify-between gap-3">
          <div>
            <h3 className="font-black text-lg font-display">{title}</h3>
            {subtitle && <p className="text-xs text-[#A3D9A5]">{subtitle}</p>}
          </div>
          {badge && (
            <span className="text-xs bg-[#1E5631] px-2.5 py-1 rounded font-bold whitespace-nowrap">{badge}</span>
          )}
        </div>
        <div className="p-2 overflow-x-auto">
          <table className="w-full text-left text-xs sm:text-sm price-table">
            <thead>
              <tr className="border-b border-[#D7E5D9] text-[#1E5631] font-bold">
                <th className="p-3" scope="col">Leistung</th>
                <th className="p-3" scope="col">Einheit</th>
                <th className="p-3 text-right" scope="col">Netto</th>
                <th className="p-3 text-right" scope="col">Brutto</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E6EFE7] text-[#1B281B]">
              {rows.map((r) => (
                <tr key={r.name} className={r.highlight ? "font-semibold" : ""}>
                  <td className="p-3 font-semibold">{r.name}</td>
                  <td className="p-3 text-[#5D7761]">{r.unit}</td>
                  <td className="p-3 text-right font-bold text-[#1E5631] whitespace-nowrap">{r.netto}</td>
                  <td className="p-3 text-right font-medium whitespace-nowrap">{r.brutto}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="p-4 bg-[#F8FAF8] border-t border-[#D7E5D9] text-xs text-[#5D7761] flex flex-wrap gap-2 justify-between items-center">
        <span>{footnote}</span>
        <Link to="/kontakt" data-testid={`${testid}-cta`} className="text-[#1E5631] font-bold underline">
          Termin anfragen
        </Link>
      </div>
    </div>
  );
}
